module.exports = __webpack_public_path__ + "media/images/2-669d4d42bcf1c299bdf801b3c6add4bd.jpg";